// Generated by ReScript, PLEASE EDIT WITH CARE

import Dayjs from "dayjs";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as DayJs$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/day-js/DayJs.mjs";
import * as Sentry$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/sentry/Sentry.mjs";
import * as CityDom$PorterinFeature from "../../../../shared/core/helpers/CityDom.mjs";
import * as UtmUtils$PorterinFeature from "../../../fare-estimate-v1/utils/utm-utils/UtmUtils.mjs";
import * as PnMStoreEn$PorterinFeature from "../store/PnMStoreEn.mjs";
import * as CookieUtils$PorterinFeature from "../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as CommonHelper$PorterinFeature from "../../../../shared/core/helpers/CommonHelper.mjs";
import * as FormValidationUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/FormValidationUtils.mjs";
import * as PnmHouseSize$PorterinFeature from "../types/PnmHouseSize.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../../shared/core/helpers/EventsTrackerHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../shared/core/helpers/PublishEventsHelper.mjs";

function getGeoregionId(shifting_type) {
  switch (shifting_type.TAG | 0) {
    case /* Inter */0 :
        return shifting_type._0.pickup_geo_region_id;
    case /* Intra */1 :
    case /* Labour */2 :
        return shifting_type._0;
    
  }
}

var normalizeToString = (function(value) {
    if (Array.isArray(value)) {
      return typeof value[0] === 'string' ? value[0] : '';
    }
    return typeof value === 'string' ? value : '';
  });

function normalizeQueryParamValue(param) {
  if (param === undefined) {
    return ;
  }
  var stringValue = normalizeToString(param);
  var trimmed = $$String.trim(stringValue);
  if (trimmed.length === 0) {
    return ;
  } else {
    return trimmed;
  }
}

function extractUtmParams(queryParams) {
  var utm_source = normalizeQueryParamValue(Js_dict.get(queryParams, "utm_source"));
  var utm_medium = normalizeQueryParamValue(Js_dict.get(queryParams, "utm_medium"));
  var utm_campaign = normalizeQueryParamValue(Js_dict.get(queryParams, "utm_campaign"));
  var utm_term = normalizeQueryParamValue(Js_dict.get(queryParams, "utm_term"));
  if (utm_source === undefined && utm_medium === undefined && utm_campaign === undefined && utm_term === undefined) {
    return ;
  }
  return {
          utm_source: utm_source,
          utm_medium: utm_medium,
          utm_campaign: utm_campaign,
          utm_term: utm_term
        };
}

function extractClickId(queryParams) {
  var gclid = normalizeQueryParamValue(Js_dict.get(queryParams, "gclid"));
  var fbclid = normalizeQueryParamValue(Js_dict.get(queryParams, "fbclid"));
  if (gclid !== undefined || fbclid !== undefined) {
    return {
            gclid: gclid,
            fbclid: fbclid
          };
  }
  
}

function extractMarketingParamsFromQuery(queryParams) {
  var utm_params = extractUtmParams(queryParams);
  var click_id = extractClickId(queryParams);
  return {
          utm_params: utm_params,
          click_id: click_id
        };
}

function isMarketingParamsEmpty(params) {
  var match = params.utm_params;
  var match$1 = params.click_id;
  if (match !== undefined) {
    return false;
  } else {
    return match$1 === undefined;
  }
}

function parseMarketingParams(queryParams) {
  try {
    var params = extractMarketingParamsFromQuery(queryParams);
    if (isMarketingParamsEmpty(params)) {
      return ;
    } else {
      return params;
    }
  }
  catch (exn){
    Sentry$PorterinUtils.captureException("PnMHelper.parseMarketingParams: failed to parse marketing params");
    return ;
  }
}

function getCreatePnMLeadData(base_form_data, is_desktop, shifting_type, marketing_params) {
  return {
          base_form: base_form_data,
          source: PnMStoreEn$PorterinFeature.order_interest_website_source,
          source_detail: is_desktop ? PnMStoreEn$PorterinFeature.order_interest_desktop_source : PnMStoreEn$PorterinFeature.order_interest_mobile_source,
          user_id: {
            web_user_id: CookieUtils$PorterinFeature.webTrackingIdSafely(undefined),
            customer_uuid: undefined
          },
          shifting_type: shifting_type,
          marketing_params: marketing_params
        };
}

function getCustomerShiftReqBasicDetails(base_form_info, house_type, source, shifting_type) {
  return {
          customer_details: {
            name: base_form_info.name,
            mobile: base_form_info.mobile,
            email: undefined,
            alternate_mobile: undefined
          },
          geo_region_id: shifting_type !== undefined ? getGeoregionId(shifting_type) : base_form_info.geo_region_id,
          shifting_date: Belt_Option.mapWithDefault(base_form_info.date, undefined, (function (x) {
                  return Caml_option.some(new Date(x.setHours(x.getHours(), 0.0)));
                })),
          house_type: house_type,
          opportunity_id: undefined,
          shifting_type: shifting_type,
          source: source
        };
}

function getEventCategory(city_name, category) {
  if (category === "Home") {
    return "Home";
  } else if (city_name !== undefined) {
    return "Packers Movers - " + city_name;
  } else {
    return "Packers Movers";
  }
}

function validateAddressWithoutBounds(address) {
  if ($$String.trim(address.landmark).length !== 0 && CommonHelper$PorterinFeature.hasAtleastOneAlphabet(address.landmark)) {
    if (address.location.lat > 0.0 && address.location.lat < 1000.0) {
      return {
              TAG: /* Ok */0,
              _0: address
            };
    } else {
      return {
              TAG: /* Error */1,
              _0: PnMStoreEn$PorterinFeature.no_result_found_text
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: PnMStoreEn$PorterinFeature.enter_valid_address_text
          };
  }
}

function validateMobileNumber(number) {
  if (number === "") {
    return {
            TAG: /* Error */1,
            _0: PnMStoreEn$PorterinFeature.no_mobile_found_text
          };
  }
  var _error = FormValidationUtils$Catalyst.validateMobileNumber(number);
  if (_error.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: _error._0
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: PnMStoreEn$PorterinFeature.enter_valid_mobile_text
          };
  }
}

function yesterday(param) {
  return Dayjs().subtract(1.0, "day").endOf("day");
}

function validateDate(date) {
  var dateDayJs = Dayjs(date);
  if (dateDayJs.isValid()) {
    if (dateDayJs.isBefore(yesterday(undefined))) {
      return {
              TAG: /* Error */1,
              _0: PnMStoreEn$PorterinFeature.invalid_date_text
            };
    } else {
      return {
              TAG: /* Ok */0,
              _0: date
            };
    }
  } else {
    return {
            TAG: /* Error */1,
            _0: PnMStoreEn$PorterinFeature.enter_valid_date_text
          };
  }
}

function getMinDate(param) {
  if (Dayjs().hour() >= PnMStoreEn$PorterinFeature.booking_end_time) {
    return DayJs$PorterinUtils.tomorrow(undefined);
  } else {
    return DayJs$PorterinUtils.today(undefined);
  }
}

function getMaxDate(param) {
  var date = getMinDate(undefined);
  return new Date(date.setDate(date.getDate() + PnMStoreEn$PorterinFeature.booking_max_date - 1.0));
}

function getCustomerId(mobile) {
  return " Mobile Number : " + mobile + ", WebTrackingID : " + CookieUtils$PorterinFeature.getCookie(UtmUtils$PorterinFeature.web_tracking_id);
}

function getDateString(date) {
  return Belt_Option.mapWithDefault(date, "", (function (x) {
                return Dayjs(x).format("YYYY-MM-DD");
              }));
}

function getBaseFormSubmitEventLabel(city, name, mobile, date) {
  return city + ("_" + (name + ("_" + (mobile + ("_" + date)))));
}

function getPnMBaseFormPayload(base_form) {
  return {
          PnM_parameter: Belt_Option.mapWithDefault(base_form.geo_region_id, "", CityDom$PorterinFeature.geoRegionIdToCity) + "_" + base_form.mobile + "_" + Belt_Option.mapWithDefault(base_form.date, "", (function (x) {
                  return Dayjs(x).format("DD-MM-YYYY");
                }))
        };
}

function publishPnMBaseFormEventParameter(base_form) {
  EventsTrackerHelper$PorterinFeature.publishEventParameter(PnMStoreEn$PorterinFeature.pnm_ga_event_parameter_label, getPnMBaseFormPayload(base_form));
}

function publishBaseFormSubmittedGaEvent(base_form, category, shifting_type) {
  var event_label = getBaseFormSubmitEventLabel(CityDom$PorterinFeature.geoRegionIdToCity(Belt_Option.getWithDefault(base_form.geo_region_id, 3)), base_form.name, base_form.mobile, getDateString(base_form.date));
  EventsTrackerHelper$PorterinFeature.publishEventParameter(PnMStoreEn$PorterinFeature.pnm_ga_event_parameter_label, getPnMBaseFormPayload(base_form));
  if (category === "Home") {
    PublishEventsHelper$PorterinFeature.publishEvents(category, PnMStoreEn$PorterinFeature.pnm_ga_marketing_campaign_event_home, event_label);
  }
  PublishEventsHelper$PorterinFeature.publishEvents(category, PnMStoreEn$PorterinFeature.pnm_ga_marketing_campaign_event, event_label);
  PublishEventsHelper$PorterinFeature.publishEvents(category, PnMStoreEn$PorterinFeature.pnm_ga_marketing_campaign_event_v2, event_label);
  PublishEventsHelper$PorterinFeature.publishEvents(category, PnMStoreEn$PorterinFeature.pnm_ga_base_form_submit, event_label);
  switch (shifting_type.TAG | 0) {
    case /* Inter */0 :
        return PublishEventsHelper$PorterinFeature.publishEvents(category, PnMStoreEn$PorterinFeature.pnm_ga_base_form_submit_inter_city, event_label);
    case /* Intra */1 :
        return PublishEventsHelper$PorterinFeature.publishEvents(category, PnMStoreEn$PorterinFeature.pnm_ga_base_form_submit_intra_city, event_label);
    case /* Labour */2 :
        return ;
    
  }
}

function getSrExternalId(pnm_form_response) {
  if (pnm_form_response !== undefined && pnm_form_response.TAG === /* Ok */0) {
    return pnm_form_response._0;
  } else {
    return "";
  }
}

function getCtaExperimentPayload(base_form, web_tracking_id) {
  return {
          PnM_parameter_CTA_exp: Belt_Option.mapWithDefault(base_form.geo_region_id, "", CityDom$PorterinFeature.geoRegionIdToCity) + "_" + base_form.mobile + "_" + Belt_Option.mapWithDefault(base_form.date, "", (function (x) {
                  return Dayjs(x).format("DD-MM-YYYY");
                })),
          web_tr_id: web_tracking_id
        };
}

function createAddress(landmark, $$location, postalAddress) {
  return {
          landmark: landmark,
          location: $$location,
          extended_address: {
            state: postalAddress.state,
            city: postalAddress.city,
            pincode: postalAddress.pincode,
            locality: postalAddress.locality,
            sub_locality: postalAddress.sub_locality
          }
        };
}

function isEmpty(val) {
  return val.length === 0;
}

function houseSizeEventName(show_house_size, house_size) {
  if (show_house_size) {
    if (house_size !== undefined) {
      return PnMStoreEn$PorterinFeature.houseSizeEvent + PnmHouseSize$PorterinFeature.toString(house_size);
    } else {
      return PnMStoreEn$PorterinFeature.houseSizeEvent + PnMStoreEn$PorterinFeature.noHouseSizeEvent;
    }
  } else {
    return PnMStoreEn$PorterinFeature.houseSizeEvent + PnMStoreEn$PorterinFeature.houseSizeNotShownEvent;
  }
}

function publishHouseSizeGaEvent(show_house_size, house_size) {
  if (show_house_size === undefined) {
    return ;
  }
  var eventName = houseSizeEventName(show_house_size, house_size);
  PublishEventsHelper$PorterinFeature.publishEvents(PnMStoreEn$PorterinFeature.pnm_ga_base_form_submit, eventName, undefined);
}

function selectInputItemStyles(item, styles, selected_item) {
  if (selected_item !== undefined && selected_item === item) {
    return styles.option + " " + styles.selected;
  } else {
    return styles.option;
  }
}

function accordionStyles(is_open, styles) {
  if (is_open) {
    return styles.icon + " " + styles.open;
  } else {
    return styles.icon;
  }
}

function validateHouseSize(show_house_field, house) {
  if (show_house_field && house === undefined) {
    return {
            TAG: /* Error */1,
            _0: PnMStoreEn$PorterinFeature.houseSizeErrorText
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: house
          };
  }
}

export {
  getGeoregionId ,
  normalizeToString ,
  normalizeQueryParamValue ,
  extractUtmParams ,
  extractClickId ,
  extractMarketingParamsFromQuery ,
  isMarketingParamsEmpty ,
  parseMarketingParams ,
  getCreatePnMLeadData ,
  getCustomerShiftReqBasicDetails ,
  getEventCategory ,
  validateAddressWithoutBounds ,
  validateMobileNumber ,
  yesterday ,
  validateDate ,
  getMinDate ,
  getMaxDate ,
  getCustomerId ,
  getDateString ,
  getBaseFormSubmitEventLabel ,
  getPnMBaseFormPayload ,
  publishPnMBaseFormEventParameter ,
  publishBaseFormSubmittedGaEvent ,
  getSrExternalId ,
  getCtaExperimentPayload ,
  createAddress ,
  isEmpty ,
  houseSizeEventName ,
  publishHouseSizeGaEvent ,
  selectInputItemStyles ,
  accordionStyles ,
  validateHouseSize ,
}
/* dayjs Not a pure module */
